import { getItemByCode, getTranslationResource, countries as staticCountries } from '@pba/static-data';

const transformCountry = (country: (typeof staticCountries)[number]) => ({
  code: country.code,
  translationKey: country.name.en,
});

export const countries = staticCountries.map((country) => transformCountry(country));

export const getTranslationCountries = (language: keyof (typeof staticCountries)[number]['name']) =>
  getTranslationResource(staticCountries, language);

export const findCountryByCode = (code?: string) => {
  const country = getItemByCode(staticCountries, code ?? '');

  return country ? transformCountry(country) : undefined;
};
